import React, { useState } from 'react';
import { PenlySeo, ContentBoxContainer, Feedback, ContentBoxText,  Spacer, Button, Loader, VideoPlayer } from 'components';

const Maintenance = ( { title, message, date } ) => (
    <>
        <header></header>
        <main className="maintenance">
            <ContentBoxContainer className="fluid">
                <ContentBoxText className="center single80 paddingSmall">
                    <h2 className="">{ title }</h2>
                    <br/>
                    <p className="large largeLineheight">
                        { message }
                    </p>
                    { date &&
                        <>
                            <br/>
                            <div className="date">{ date }</div>
                        </>
                    }

                </ContentBoxText>
            </ContentBoxContainer>
        </main>
        <footer>
            <section>
                <ul>
                    <li>
                        <div></div>
                        <p>
                            Symbion<br />
                            Fruebjergvej 3
                            <br />
                            2100 København Ø
                            <br />
                            CVR 39063158
                        </p>
                    </li>
                </ul>
            </section>
        </footer>
    </>
);

export default Maintenance;
